module.exports = __webpack_public_path__ + "img/special_liftserum_202402.0927fd9c.jpg";